<template>
	<div>
		<h1>{{ $t('connect.forgotten_password') }}</h1>
		<b-form @submit="onSubmit">
			<b-form-group
				id="username_group"
				:label="$t('connect.login') "
				label-for="username">
				<b-form-input
					id="username"
					type="text"
					v-model="username"
					required
					placeholder="username"></b-form-input>
			</b-form-group>
			<b-button type="submit" variant="primary">{{ $t('ui.validate') }}</b-button>
		</b-form>
		<div>
			<b-alert v-if="error" show>{{ errorMsg }}</b-alert>
		</div>
	</div>
</template>

<script>
	import password from "../services/password.js";

	export default {
		name: "password_reset",
		data() {
			return {
				username: "",
				error: false,
				errorMsg: null,
			};
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				password.password_reset(this.username).then((res) => {
					//console.log(res)
					this.$router.push({ name: "login" });
				});
			},
		},
	};
</script>

<style></style>
